import { create } from 'zustand';
import { barcodeScanApi, type BarcodeScan, type BarcodeScanOutcome } from '../api/barcodeScans';

interface BarcodeScanState {
  items: BarcodeScan[];
  loading: boolean;
  bindingScan: BarcodeScan | null;
  _pollInterval: number | null;
  refreshItems: () => Promise<void>;
  startPolling: () => void;
  stopPolling: () => void;
  updateOutcome: (id: number, outcome: BarcodeScanOutcome) => void;
  removeItem: (id: number) => void;
  openBinding: (scan: BarcodeScan) => void;
  closeBinding: () => void;
}

const useBarcodeScanStore = create<BarcodeScanState>((set, get) => ({
  items: [],
  loading: false,
  bindingScan: null,
  _pollInterval: null,

  async refreshItems() {
    set({ loading: true });
    try {
      const rows = await barcodeScanApi.pending();
      const previous = new Map(get().items.map(item => [item.id, { product: item.product, knowledge: item.knowledge }]));
      set({
        items: rows.map(item => ({
          ...item,
          product: previous.get(item.id)?.product,
          knowledge: previous.get(item.id)?.knowledge,
        })),
      });
    } finally {
      set({ loading: false });
    }
  },

  startPolling() {
    if (get()._pollInterval !== null) return;
    void get().refreshItems().catch(() => undefined);
    const handle = window.setInterval(() => {
      void get().refreshItems().catch(() => undefined);
    }, 5000);
    set({ _pollInterval: handle });
  },

  stopPolling() {
    const handle = get()._pollInterval;
    if (handle !== null) clearInterval(handle);
    set({ _pollInterval: null, bindingScan: null });
  },

  updateOutcome(id, outcome) {
    set({ items: get().items.map(item => item.id === id ? { ...item, outcome } : item) });
  },

  removeItem(id) {
    set({ items: get().items.filter(item => item.id !== id) });
  },

  openBinding(scan) {
    set({ bindingScan: scan });
  },

  closeBinding() {
    set({ bindingScan: null });
  },
}));

export default useBarcodeScanStore;
